import { GetEmployeesPayload } from 'src/api/endpoints/employees/types'
import { Filial, ResponseWrapper, Role } from 'src/api/endpoints/users/users.types.new'
import { baseApi, QueryPayload } from 'src/api'

export type EmployeeView = {
    id: number;
    login: string;
    role: Role;
    avatarURL: string | null;
    name: string;
    surname: string;
    filial: Filial;
    canBeEdited: boolean;
    canBeDeactivated: boolean,
    canBeActivated: boolean,
    active: boolean,
};

export type GetEmployeesResponse = {
    items: EmployeeView[],
    meta: {
        offset: 0,
        total: 0
    }
}

const api = baseApi.injectEndpoints({
    endpoints: builder => ({
        getEmployees: builder.query<GetEmployeesResponse, GetEmployeesPayload>({
            providesTags: ['Employee'],
            query: (payload: GetEmployeesPayload): QueryPayload => {
                return {
                    url: '/employees',
                    params: payload.params,
                    method: 'GET',
                    errorMessage: 'Не удалось получить информацию о пользователях!',
                }
            },
        }),
        activateEmployee: builder.mutation<
            ResponseWrapper<null>,
            { path: { employeeId: number } }
        >({
            invalidatesTags: ['Employee'],
            query: (payload): QueryPayload => ({
                url: `/employees/${payload.path.employeeId}/activate`,
                method: 'POST',
                errorMessage: 'Не удалось активировать сотрудника',
            }),
        }),
        deactivateEmployee: builder.mutation<
            ResponseWrapper<null>,
            { path: { employeeId: number } }
        >({
            invalidatesTags: ['Employee'],
            query: (payload): QueryPayload => ({
                url: `/employees/${payload.path.employeeId}/deactivate`,
                method: 'POST',
                errorMessage: 'Не удалось деактивировать сотрудника',
            }),
        }),
    }),
})

export const {
    useGetEmployeesQuery,
    useActivateEmployeeMutation,
    useDeactivateEmployeeMutation,
} = api
